import { useEffect, useState } from 'react';

import { openSupportForm } from 'store/user/actions';

import { ONGOING_EXPERIMENTS } from 'constants/eppo';

import { sendAnalyticSideBarElementClick } from 'services/Analytics';
import { ActionEventAction } from 'services/Analytics/core';
import { getAbTestName } from 'services/Analytics/helpers';
import { getJsonSafe } from 'services/Eppo';

import { useDispatch } from 'hooks/store';

const useContactUsAction = (closeSidebar: () => void) => {
    const dispatch = useDispatch();
    const [chatIsVisible, setChatIsVisible] = useState<boolean>(false);

    useEffect(() => {
        const { visible } = getJsonSafe<{ visible: boolean }>({
            flag: ONGOING_EXPERIMENTS.ContactUsChat,
            def: { visible: false },
        });

        setChatIsVisible(visible);
    }, []);

    const onClickContactUs = () => {
        sendAnalyticSideBarElementClick(ActionEventAction.contactUs, {
            ab_test_name: getAbTestName({
                experiment: ONGOING_EXPERIMENTS.ContactUsChat,
                variantName: chatIsVisible ? 'visible' : 'invisible',
            }),
        });

        closeSidebar();

        dispatch(openSupportForm({ chatIsVisible }));
    };

    return { onClickContactUs };
};

export { useContactUsAction };
